import { KatFileUploadStatus } from '@amzn/katal-components/es/file-upload';
import { KatFileUpload, KatInput } from '@amzn/katal-react';
import { AssetStatus, IAssetInputHandler, InputType } from 'src/types';

export interface AssetInputProps {
  /**
   * Label for the input component
   */
  label: string;
  /**
   * Handler for asset input operations
   */
  assetInputHandler: IAssetInputHandler;
  /**
   * Accepted file types for upload
   */
  acceptedFileTypes: KatFileUpload.Props['accept'];
  /**
   * Maximum file size in bytes
   */
  maxFileSizeInBytes: KatFileUpload.Props['maxSize'];
  /**
   * Error message to display
   */
  error?: string;
  /**
   * Current status of the asset
   */
  status?: AssetStatus;
}

export interface FileUploadState {
  fileUploadState: {
    status: KatFileUploadStatus;
    error: string;
  };
}

export interface ConfirmationDialogProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export interface StatusIndicatorProps {
  error?: string;
  status?: AssetStatus;
}

export interface UrlInputProps {
  url: string;
  onChange: (event: KatInput.ChangeEvent) => void;
  onFetch: () => void;
  isValidUrl: boolean;
  isFetching: boolean;
}

export const INPUT_OPTIONS = [
  { label: 'Upload', value: InputType.UPLOAD },
  { label: 'URL', value: InputType.URL },
] as const;
